export default __webpack_public_path__ + "static/media/left-arrow.072fd518.svg";